import createSelector from "../../utils/reselect";

const allocatedResourcesStateData = (state) => {
  const { allocatedResources } = state;
  return allocatedResources || {};
};

export const resources = createSelector(
  allocatedResourcesStateData,
  (allocatedResources) => allocatedResources.get("resources")
);

export const loading = createSelector(
  allocatedResourcesStateData,
  (allocatedResources) => allocatedResources.get("loading")
);

export const resourcesPagination = createSelector(
  allocatedResourcesStateData,
  (allocatedResources) => allocatedResources.get("resourcesPagination")
);
